<template>
  <v-container class="payment-container">
    <v-card flat class="futuristic-card">
      <v-card-title class="card-header">
        <div>
          <h4 class="earth-color">Visiting History</h4>
          <div class="title-decoration"></div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
          class="futuristic-search"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="columns"
        :items="allVisitors"
        :search="search"
        :pagination.sync="pagination"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        class="futuristic-table"
      >
        <v-progress-linear slot="progress" color="#587e27" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td data-label="Time In">{{ formated_date_time(props.item.visitor_start_time) }}</td>
          <td data-label="Time Out">
            <span v-if="props.item.visitor_end_time !== null">{{ formated_date_time(props.item.visitor_end_time) }}</span>
            <span v-if="props.item.visitor_end_time === null">Visitor is still in</span>
          </td>
          <td data-label="Organization">{{ props.item.visitor_organisation }}</td>
          <td data-label="Person">{{ props.item.visitor_name }}</td>
          <td data-label="Visitor Type">{{ props.item.visitor_type_name }}</td>
          <td data-label="Visitation Status">{{ props.item.status }}</td>
          <td data-label="Persons">{{ props.item.visitor_count }}</td>
          <td data-label="Responsible Staff">{{ props.item.visitor_staff_responsible_name }}</td>
          <td data-label="Action">
            <v-btn
              :depressed="true"
              small
              color="#587e27"
              @click="viewVisitor(props.item.visitor_public_id)"
              class="futuristic-btn"
            >View Details</v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 lg3>
            <v-select
              :items="rowsPerPageItems"
              v-model="pagination.rowsPerPage"
              label="Rows per page"
              class="futuristic-input"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      search: '',
      columns: [
        {
          text: 'Time In',
          value: 'visitor_start_time'
        },
        {
          text: 'Time Out',
          value: 'visitor_end_time'
        },
        {
          text: 'Organization',
          value: 'visitor_organisation'
        },
        {
          text: 'Person',
          value: 'visitor_name'
        },
        {
          text: 'Visitor Type',
          value: 'type'
        },
        {
          text: 'Visitation Status',
          value: 'status'
        },
        {
          text: 'Persons',
          value: 'persons'
        },
        {
          text: 'Responsible Staff',
          value: 'visitor_staff_responsible_name'
        },
        {
          text: 'Action',
          value: ''
        }
      ],
      pagination: {
        rowsPerPage: 10
      },
      rowsPerPageItems: [10, 25, { text: 'All', value: -1 }]
    }
  },
  created () {
    this.$store.dispatch('get_all_visitors')
  },
  methods: {
    viewVisitor: function (publicId) {
      this.$router.push({
        name: 'Visitor',
        params: {
          visitor_id: publicId
        }
      })
    }
  }
}
</script>

<style scoped>
/* Futuristic Container */
.payment-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.payment-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.futuristic-table {
  border-radius: 8px;
  background: #ffffff;
}

.futuristic-table >>> th {
  color: #587e27;
  font-weight: 600;
}

.futuristic-link {
  color: #587e27;
  text-decoration: none;
  transition: color 0.2s ease;
}

.futuristic-link:hover {
  color: #1b5e20;
}

.futuristic-alert {
  border-radius: 8px;
  background: #fff5f5;
}

.futuristic-search >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .payment-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }

  .futuristic-btn {
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .payment-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.1rem;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }
}
</style>